// Reglas del sistema sobre el catálogo de sucursales de LCApii: cuáles quedan
// fuera de esta app y con qué nombre se muestran ("Nombre - NN", con alias).
// Módulo puro y sin imports para poder testearlo con `npm test`.
//
// Las dos reglas vienen en `datosSistema` de LCApii, que llega con cada
// validación de sesión. Cambiarlas es editar ese campo: sin build ni deploy.
//
//   { "sucursales_excluidas": [91, 92], "sucursales_alias": { "15": "Ventas Web" } }
//
// La exclusión es lista negra a propósito: una sucursal nueva entra sola, y si
// no corresponde se la saca desde LCApii. El alias pisa el nombre solo en
// pantalla: el registro de auditoría sigue congelando el nombre original.

/**
 * Lee las reglas del JSON de `datosSistema`. Sin dato o con dato malformado
 * no se excluye nada y no hay alias. El alias es un objeto plano (no un Map)
 * porque la sesión se guarda en localStorage como JSON.
 */
export function parsearReglas(datosSistema) {
  let datos;
  try {
    datos = typeof datosSistema === "string" ? JSON.parse(datosSistema || "{}") : datosSistema;
  } catch {
    datos = null;
  }

  const excluidas = Array.isArray(datos?.sucursales_excluidas)
    ? datos.sucursales_excluidas
        .filter((id) => id !== null && id !== "")
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id))
    : [];

  const alias = {};
  const crudo = datos?.sucursales_alias;
  if (crudo && typeof crudo === "object" && !Array.isArray(crudo)) {
    for (const [clave, nombre] of Object.entries(crudo)) {
      const id = Number.parseInt(clave, 10);
      if (Number.isNaN(id) || typeof nombre !== "string" || !nombre.trim()) continue;
      alias[id] = nombre.trim();
    }
  }

  return { excluidas, alias };
}

/**
 * Saca las sucursales excluidas por el sistema. Gana sobre lo que tenga el
 * usuario en `datosUsuario`: ni el comodín 0 ni una sucursal cargada a mano
 * la traen de vuelta.
 */
export function excluirSucursales(sucursales, excluidas) {
  if (!Array.isArray(excluidas) || excluidas.length === 0) return sucursales;
  const ids = excluidas.map((id) => Number(id));
  return sucursales.filter((s) => !ids.includes(Number(s.id)));
}

/** Nombre mostrado y etiqueta "Nombre - NN" de una sucursal. */
export function etiquetaSucursal(sucursal, alias = {}) {
  const id = Number(sucursal.id);
  const nombreMostrado = alias?.[id] ?? String(sucursal.nombre);
  return {
    nombreMostrado,
    etiqueta: `${nombreMostrado} - ${String(id).padStart(2, "0")}`,
  };
}
